module.exports = __webpack_public_path__ + "assets/img/index_innews_bg.ecbfc1ee.png";